import { LazyRoute } from '@app/components/lazy-route';
import React, { lazy } from 'react';

const Page = lazy(() => import('./attendee-profile-page'));

export const AttendeeProfilePage = () => {
  return (
    <LazyRoute>
      <Page />
    </LazyRoute>
  );
};
